import React from "react";
import { ShieldCheck } from "lucide-react";
import { PageHero } from "../components/ui-parts";

export default function AdminLogin() {
  const signIn = () => {
    try { sessionStorage.setItem("js_post_login_redirect", "/admin"); } catch {}
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/admin";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };
  return (
    <div data-testid="admin-login-page">
      <PageHero badge="Admin" title="Sign in to manage the platform" subtitle="Only authorised administrators can access the dashboard." />
      <section className="section">
        <div className="container-narrow max-w-md">
          <div className="js-card p-8 text-center">
            <ShieldCheck size={40} className="mx-auto text-[var(--js-primary)]" />
            <h3 className="font-heading text-xl mt-4">Sign in with Google</h3>
            <p className="text-sm text-[var(--js-muted)] mt-2">The first person to sign in becomes the site admin automatically.</p>
            <button onClick={signIn} className="js-btn-primary mt-6 w-full justify-center" data-testid="google-signin-btn">
              <svg width="16" height="16" viewBox="0 0 48 48" aria-hidden="true"><path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3c-1.6 4.6-6 8-11.3 8-6.6 0-12-5.4-12-12s5.4-12 12-12c3.1 0 5.9 1.2 8 3.1l5.7-5.7C34 6.1 29.3 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20 20-8.9 20-20c0-1.2-.1-2.3-.4-3.5z"/><path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.6 16 18.9 13 24 13c3.1 0 5.9 1.2 8 3.1l5.7-5.7C34 6.1 29.3 4 24 4 16.3 4 9.6 8.3 6.3 14.7z"/><path fill="#4CAF50" d="M24 44c5.2 0 10-2 13.6-5.3l-6.3-5.2C29.2 35 26.7 36 24 36c-5.3 0-9.7-3.3-11.3-8l-6.5 5C9.4 39.6 16.2 44 24 44z"/><path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.3-2.3 4.3-4.3 5.7l6.3 5.2c-.4.4 6.7-4.9 6.7-14.9 0-1.2-.1-2.3-.4-3.5z"/></svg>
              Continue with Google
            </button>
          </div>
        </div>
      </section>
    </div>
  );
}
